import { render, staticRenderFns } from "./ExtraInformation.vue?vue&type=template&id=5ccab228&scoped=true"
import script from "./ExtraInformation.vue?vue&type=script&lang=js"
export * from "./ExtraInformation.vue?vue&type=script&lang=js"
import style0 from "./ExtraInformation.vue?vue&type=style&index=0&id=5ccab228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccab228",
  null
  
)

export default component.exports